module.exports = __webpack_public_path__ + "static/media/bark1.e251cdce.png";